import React, { useContext } from "react";
import LoadingOverlay from "react-loading-overlay";
import { Context } from "../../context/globalContext";

// Components
import Navbar from "../../components/Navbar";
import OrdemCompraIcon from "../../assets/navbar/Front_Credito_on_light_blue.svg";
import * as S from "./styles";

import ListOrdemCompra from "../../components/ListOrdemCompra";

const OrdemCompraList = () => {
  const { loadingOverlayActive, setLoadingOverlayActive } = useContext(Context);
  const { loadingOverlayText, setLoadingOverlayText } = useContext(Context);

  return (
    <S.ContainerPage>
      <LoadingOverlay
        active={loadingOverlayActive}
        spinner
        text={loadingOverlayText}
      >
        <Navbar />
        <S.Wrapper>
          <S.Header>
            <S.BoxUser>
              <S.Image src={OrdemCompraIcon} />
              <div>
                <S.Title>Ordem de Compra</S.Title>
                <S.Description>Filtros gerais de busca</S.Description>
              </div>
            </S.BoxUser>
          </S.Header>

          <ListOrdemCompra />
        </S.Wrapper>
      </LoadingOverlay>
    </S.ContainerPage>
  );
};

export default OrdemCompraList;
